const STYLES = {
    base: 'color: #8290A1;' +
      'background-color: #fff;' +
      'padding: 0 3rem 0 1rem;' +
      'border: 1px solid rgba(47, 70, 98, 0.2);' +
      'border-radius: 0.25rem;' +
      'transition: border-color, color 200ms;' +
      'height: 3.5rem;' +
      'margin: 0;' +
      'width:100%;' +
      'outline:none;' +
      'font-size:1rem;' +
      'box-sizing: border-box;',
    focus: 'color: #2f4662;' +
      'border-color:#2ea39d;'
};


export const FORM_CONFIG = {
    pci: true,
    cvv: true,
    enablePrettyFormat: true,
    enableValidateOnBlur: false,
    enableValidateOnKeyUp: true,
    styles: {
        base: STYLES.base,
        focus: STYLES.focus,
        cvv: {
            base: STYLES.base,
            focus: STYLES.focus
        }
    },
    customDataTypes: [
        {
            type: 'privateCard',
            /* eslint-disable max-len */
            possibleRegEx: '(?!(^4\\d{0,12}(\\d{3})?(\\d{3})?$)|(^(5[1-5]\\d{4}|677189|222[1-9]\\d{2}|22[3-9]\\d{3}|2[3-6]\\d{4}|27[01]\\d{3}|2720\\d{2})\\d{0,13}$)|(^3(0[0-5]|[68]\\d)\\d{0,16}$)|(^(6011|65\\d{2}|64[4-9]\\d)\\d{0,15}|^(62\\d{0,17})$)|(^3[47]\\d{0,17}$)|(^35(28|29|[3-8]\\d)\\d{0,15}$))(^\\d{0,19}$)',
            validRegex: '(?!(^4\\d{12}(\\d{3})?(\\d{3})?$)|(^(5[1-5]\\d{4}|677189|222[1-9]\\d{2}|22[3-9]\\d{3}|2[3-6]\\d{4}|27[01]\\d{3}|2720\\d{2})\\d{10,13}$)|(^3(0[0-5]|[68]\\d)\\d{11,16}$)|(^(6011|65\\d{2}|64[4-9]\\d)\\d{12,15}|^(62\\d{14,17})$)|(^3[47]\\d{13,17}$)|(^35(28|29|[3-8]\\d)\\d{12,15}$))(^\\d{13,19}$)',
            /* eslint-enable max-len */
            maxLength: 19,
            cvvValidRegex: '^[0-9]{3,4}$',
            cvvMaxLength: 4,
            cvvRequired: false,
            luhnCheck: true,
            enforceLuhnCompliance: false
        }
    ]
};

export const ERROR_TYPE = {
    format: 'format',
    required: 'required',
    notInFuture: 'notInFuture',
    notSupportedType: 'notSupportedType'
};

export const NOT_SUPPORTED_CARD_TYPES = [
    'diners',
    'americanExpress',
    'jcb'
];

export const TOKENEX_CARD_TYPES_MAPPING = {
    diners: 'Diners',
    americanExpress: 'American Express',
    jcb: 'JCB'
};
